import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { RegionList } from '@mnc/contracts';
import { api } from '../../lib/api';
import { pick } from '../../i18n';
import { SearchableSelect } from '../ui';

/** Region picker fed by the first-class `regions` table (active rows only). */
export function RegionSelect({ value, onChange, disabled, multiple }: { value: string | string[]; onChange: (v: string | string[]) => void; disabled?: boolean; multiple?: boolean }) {
  const { t, i18n } = useTranslation();
  const regions = useQuery({ queryKey: ['regions'], queryFn: () => api.get<RegionList>('/api/regions'), staleTime: 300_000 });
  const options = useMemo(() => (regions.data?.items ?? []).map((r) => ({ value: r.code, label: pick(i18n.language, r.name_en, r.name_ar), description: r.iso_code ?? undefined })), [regions.data, i18n.language]);
  return <SearchableSelect value={value} onChange={onChange} options={options} disabled={disabled} multiple={multiple} placeholder={t('regions.pick')} />;
}
